import React, { useEffect } from "react";
import { OperationPage } from "./components/layout/OperationPage";
import "./index.css";
import { useStore } from "./store";
import { walkthroughService } from "./services/walkthroughService";

function App() {
  const initializeKeyboardControls = useStore(
    (s) => s.initializeKeyboardControls
  );
  const cleanupKeyboardControls = useStore((s) => s.cleanupKeyboardControls);
  const startMotionService = useStore((s) => s.startMotionService);
  const stopMotionService = useStore((s) => s.stopMotionService);

  // Initialize keyboard controls when component mounts
  useEffect(() => {
    initializeKeyboardControls();
    startMotionService();
    // Start the default walkthrough on app load
    walkthroughService.start("controls-training");
    return () => {
      cleanupKeyboardControls();
      stopMotionService();
      walkthroughService.stop();
    };
  }, [
    initializeKeyboardControls,
    cleanupKeyboardControls,
    startMotionService,
    stopMotionService,
  ]);
  return <OperationPage />;
}

export default App;
